import helpers from '../helpers';

// Font URLs to load
const FONT_URLS = [
  'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap',
  'https://fonts.googleapis.com/css?family=PT+Serif:400,700',
  'https://fonts.googleapis.com/css?family=Assistant:400,700&subset=hebrew',
  'https://fonts.googleapis.com/css?family=Sacramento',
  'https://fonts.googleapis.com/earlyaccess/opensanshebrew.css',
];

// Function to load Google Fonts
const loadGoogleFonts = () => {
  FONT_URLS.forEach((url) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
  });
};

// Function to load custom fonts
const loadCustomFonts = () => {
  // Create font-face rules for custom fonts
  const customFontCSS = `
    @font-face {
      font-family: "Sharpsansno1 light";
      src:
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Light.eot") format("embedded-opentype"),
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Light.woff") format("woff"),
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Light.svg?v=1") format("svg");
      font-weight: 100;
      font-style: normal;
    }

    @font-face {
      font-family: "Sharpsansno1 book";
      src:
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Book.eot") format("embedded-opentype"),
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Book.woff") format("woff"),
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Book.svg?v=1") format("svg");
      font-weight: 400;
      font-style: normal;
    }

    @font-face {
      font-family: "Sharpsansno1 book";
      src:
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Semibold.eot") format("embedded-opentype"),
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Semibold.woff") format("woff"),
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Semibold.svg?v=1") format("svg");
      font-weight: 700;
      font-style: normal;
    }

    @font-face {
      font-family: "Sharpsansno1 bold";
      src:
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Bold.eot") format("embedded-opentype"),
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Bold.woff") format("woff"),
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Bold.svg?v=1") format("svg");
      font-weight: 700;
      font-style: normal;
    }

    @font-face {
      font-family: "Sharpsansno1 semibold";
      src:
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Semibold.eot") format("embedded-opentype"),
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Semibold.woff") format("woff"),
        url("https://d18jgsx8vuja2p.cloudfront.net/SharpSansNo1-Semibold.svg?v=1") format("svg");
      font-weight: 700;
      font-style: normal;
    }
  `;

  const style = document.createElement('style');
  style.textContent = customFontCSS;
  document.head.appendChild(style);
};

// Main function to conditionally load fonts
const loadFontsConditionally = () => {
  // Only load fonts for real users, not bots
  if (!helpers.isBotOrPrerender()) {
    loadGoogleFonts();
    loadCustomFonts();
  } else {
    // For bots, use system fonts as fallback
    document.documentElement.style.setProperty(
      '--font-family',
      'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    );
  }
};

// Export the function
export default loadFontsConditionally;
